/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateLocationRequestSubscription } from './CreateLocationRequestSubscription';
import {
    CreateLocationRequestSubscriptionFromJSON,
    CreateLocationRequestSubscriptionFromJSONTyped,
    CreateLocationRequestSubscriptionToJSON,
    CreateLocationRequestSubscriptionToJSONTyped,
} from './CreateLocationRequestSubscription';
import type { CreateLocationRequestLegalInfo } from './CreateLocationRequestLegalInfo';
import {
    CreateLocationRequestLegalInfoFromJSON,
    CreateLocationRequestLegalInfoFromJSONTyped,
    CreateLocationRequestLegalInfoToJSON,
    CreateLocationRequestLegalInfoToJSONTyped,
} from './CreateLocationRequestLegalInfo';

/**
 * 
 * @export
 * @interface CreateLocationRequest
 */
export interface CreateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationRequest
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationRequest
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    provinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    neighborhood?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationRequest
     */
    newLegalEntity: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {CreateLocationRequestLegalInfo}
     * @memberof CreateLocationRequest
     */
    legalInfo: CreateLocationRequestLegalInfo;
    /**
     * 
     * @type {CreateLocationRequestSubscription}
     * @memberof CreateLocationRequest
     */
    subscription: CreateLocationRequestSubscription;
}

/**
 * Check if a given object implements the CreateLocationRequest interface.
 */
export function instanceOfCreateLocationRequest(value: object): value is CreateLocationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('newLegalEntity' in value) || value['newLegalEntity'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('legalInfo' in value) || value['legalInfo'] === undefined) return false;
    if (!('subscription' in value) || value['subscription'] === undefined) return false;
    return true;
}

export function CreateLocationRequestFromJSON(json: any): CreateLocationRequest {
    return CreateLocationRequestFromJSONTyped(json, false);
}

export function CreateLocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLocationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'],
        'countryCode': json['countryCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'city': json['city'] == null ? undefined : json['city'],
        'province': json['province'] == null ? undefined : json['province'],
        'country': json['country'] == null ? undefined : json['country'],
        'email': json['email'],
        'newLegalEntity': json['newLegalEntity'],
        'phoneNumber': json['phoneNumber'],
        'legalInfo': CreateLocationRequestLegalInfoFromJSON(json['legalInfo']),
        'subscription': CreateLocationRequestSubscriptionFromJSON(json['subscription']),
    };
}

export function CreateLocationRequestToJSON(json: any): CreateLocationRequest {
    return CreateLocationRequestToJSONTyped(json, false);
}

export function CreateLocationRequestToJSONTyped(value?: CreateLocationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'street': value['street'],
        'number': value['number'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'countryCode': value['countryCode'],
        'provinceCode': value['provinceCode'],
        'neighborhood': value['neighborhood'],
        'city': value['city'],
        'province': value['province'],
        'country': value['country'],
        'email': value['email'],
        'newLegalEntity': value['newLegalEntity'],
        'phoneNumber': value['phoneNumber'],
        'legalInfo': CreateLocationRequestLegalInfoToJSON(value['legalInfo']),
        'subscription': CreateLocationRequestSubscriptionToJSON(value['subscription']),
    };
}

